import { useMainSelector } from '../useMainSelector';

export const useGDPR = () => {
  const {
    gdpr: { gdprUsers, selectedUser, totalRecords },
  } = useMainSelector();

  return {
    users: gdprUsers,
    totalRecords,
    selectedUser,
  };
};
